import React from 'react'
import { useMsal } from '@azure/msal-react'
import Footer from './footer'
import AppHeader from './appHeader'

interface LayoutProps {
    children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => {
    const { instance, accounts } = useMsal();
    const account = instance.getActiveAccount() || accounts[0];

    return (
        <div className={'page app'}>

            {/* ReachDeck Toolbar */}
            <div id="__ba_panel"></div>

            <AppHeader displayInfo={!!account} />
            <div className="page__content">{children}</div>
            { account && <Footer />}
            {/*<LoadingSplash isLoading={isLoading} />*/}
        </div>
    )
}

export default Layout
